import { NotificationManager as notifier } from 'react-notifications';
import messages from '../constants/messages';


const clearNotifications = () => {
  notifier.listNotify = [];
};

export const notifyInfo = (message=messages.common.saveSuccess) => {
  clearNotifications();
  notifier.info(message);
};

export const notifyError = (message=messages.common.error) => {
  clearNotifications();
  notifier.error(message);
};


// WEBPACK FOOTER //
// src/utils/notifier.js